const API_URL = process.env.REACT_APP_API_URL;

export async function createClef(data) {
  const response = await fetch(`${API_URL}/clef`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      api: {
        module: data.module,
        permissions: data.permissions,
        expiration: data.expiration,
      },
    }),
  });

  if (!response.ok) throw new Error("Erreur lors de la création de la clé API");

  const body = await response.json();
  return body?.key ?? body?.data?.key ?? null;
}

export async function getClefs() {
  const response = await fetch(`${API_URL}/clef`, {
    method: "GET",
    credentials: "include",
  });

  if (!response.ok) throw new Error("Erreur lors de la récupération des clés API");

  return response.json();
}

export async function updateClef(id, data) {
  const response = await fetch(`${API_URL}/clef/${id}`, {
    method: "PUT",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      api: { expiration: data.expiration },
    }),
  });

  if (!response.ok) throw new Error("Erreur lors de la mise à jour de la clé API");

  return response.json();
}

export async function deleteClef(id) {
  const response = await fetch(`${API_URL}/clef/${id}`, {
    method: "DELETE",
    credentials: "include",
  });

  if (!response.ok) throw new Error("Erreur lors de la révocation de la clé API");

  return response.json();
}
